<script>
  // The same six-line block was pasted four times, differing only in which
  // link carried `tab-active`.
  //
  // The fourth copy's condition was `{:else if current_page = "/error"}` -- a
  // single `=`. That assigns rather than compares, always evaluates truthy, and
  // clobbers current_page on the way through, so the Error tab doubled as the
  // fallback branch for every unrecognised path (P1-10).
  //
  // Worth knowing: ESLint does NOT catch this. no-cond-assign is enabled and
  // fires on the identical construct in a .js file, but eslint-plugin-svelte
  // does not run core rules over template expressions. Prettier made it worse
  // by wrapping the assignment in parentheses -- its convention for "this is
  // deliberate". Expressing the tabs as data rather than markup is what
  // actually removes the possibility.
  //
  // Counts are additive: if /file/counts fails the tabs render exactly as they
  // did before, because a badge is not worth blocking navigation over.
  //
  // They come from a store, not a local fetch, so that a delete elsewhere on
  // the page can update them. Otherwise the badge and the section heading
  // disagree the moment anything is removed.
  import { onMount } from "svelte";
  import { counts, refreshCounts } from "../lib/counts.js";

  export let current = window.location.pathname;

  const TABS = [
    { key: "ready", href: "/", label: "Ready" },
    { key: "queue", href: "/queue", label: "Busy / Queue" },
    { key: "solved", href: "/solved", label: "Solved" },
    { key: "error", href: "/error", label: "Error" },
  ];

  onMount(refreshCounts);
</script>

<nav class="flex justify-center" aria-label="Job status">
  <div class="inline-flex gap-1 rounded-btn bg-base-200 p-1">
    {#each TABS as tab (tab.href)}
      <a
        href={tab.href}
        aria-current={current === tab.href ? "page" : undefined}
        class="flex items-center gap-1.5 rounded-btn px-3 py-1.5 text-sm transition-colors
               {current === tab.href
          ? 'bg-base-100 font-medium shadow-sm'
          : 'opacity-60 hover:opacity-100'}"
      >
        {tab.label}
        {#if $counts && $counts[tab.key] > 0}
          <span class="text-xs tabular-nums opacity-60">{$counts[tab.key]}</span
          >
        {/if}
      </a>
    {/each}
  </div>
</nav>
